<ng-container *transloco="let t; read: 'configuration'">
<div>
    <h1 class="text-2xl font-medium">{{ t('stateConfiguration.childUpload.title') }}</h1>
    <div class="flex flex-col pt-5">
        <div class="col-span-1">
            <label>{{ t('stateConfiguration.childUpload.allInstrumentLabel') }}</label>
            <span class="pl-0 sm:pl-4 whitespace-nowrap"><i class="uil uil-file-download text-drdpblue-300 text-xl"></i>
                <button class="pl-1" (click)="downloadFile()">{{ t('stateConfiguration.childUpload.download') }}</button>
            </span>
            <span class="pl-4 whitespace-nowrap"><i class="uil uil-upload text-drdpblue-300 text-xl"></i>
                <input type="file" class="file-input"(change)="onFileSelected($event)" #fileUpload>
                <button class="pl-1" (click)="fileUpload.click()">{{ t('stateConfiguration.childUpload.upload') }}</button>
            </span>
        </div>
    </div>
</div>
</ng-container>
